import PageHero from "../components/PageHero";
import projects from "../data/projects";

function Projects() {
  return (
    <main>
      <PageHero
        title="Projects"
        text="In our years of operation, we have completed numerous projects with partners from around the world, supporting innovation, sustainability, employability, digital learning and the blue economy."
      />

      <section className="section">
        <div className="projects-grid">
          {projects.map((project) => (
            <article className="project-card" key={project.title}>
              <div className="project-image">
                <img src={project.image} alt={project.title} />
              </div>

              <div className="project-content">
                <h2>{project.title}</h2>
                <p>{project.description}</p>

                {project.url !== "#" && (
                  <a
                    href={project.url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-link"
                  >
                    Visit project website
                  </a>
                )}

                {project.url === "#" && (
                  <span className="text-link muted-link">
                    Project website coming soon
                  </span>
                )}
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}

export default Projects;